import { useSuspenseQuery } from "@apollo/client/react";
import {
  GetEntitiesModelContextDocument,
  type GetEntitiesModelContextQuery,
  type GetEntitiesModelContextQueryVariables,
} from "~/features/entities/gqls";
import { useTenant } from "~/features/tenant/context";

/** Lookup data for the search sidebar: entity categories + references. */
export function useEntityModelContext() {
  const { tenantId } = useTenant();
  if (!tenantId) throw new Error("Tenant ID is required");
  const { data } = useSuspenseQuery<GetEntitiesModelContextQuery, GetEntitiesModelContextQueryVariables>(
    GetEntitiesModelContextDocument,
    { variables: { tenantId } },
  );
  return { entityCategories: data.entityCategories, references: data.references };
}
